
//decoradores
import { Component, Prop, Vue } from "vue-property-decorator";
//tipos
import { Chofer } from "@/typings/store/plugins/easyFirestore/choferes";
//componentes
import SvgIcon from "@/components/custom/SvgIcon.vue";

@Component({
  components: { SvgIcon },
})
export default class MenuInfoChofer extends Vue {
  @Prop() readonly chofer!: Chofer | null;
  @Prop({ type: Boolean }) readonly top!: boolean;
  @Prop() readonly parent!: string;

  width = 0;

  get noValueMessage(): string {
    return this.$t(`${this.parent}.menu.no-value-message`) as string;
  }

  get nombre(): string {
    return this.chofer?.nombre || this.noValueMessage;
  }

  get rut(): string {
    return this.chofer?.rut || this.noValueMessage;
  }

  get cargo(): string {
    return this.chofer?.cargo || this.noValueMessage;
  }

  get fechaNacimiento(): string {
    return (
      this.chofer?.fechaNacimiento?.toDate()?.format("DD-MM-YYYY") ||
      this.noValueMessage
    );
  }

  get fechaContratacion(): string {
    return (
      this.chofer?.fechaContratacion?.toDate()?.format("DD-MM-YYYY") ||
      this.noValueMessage
    );
  }

  get telefono(): string {
    return this.chofer?.contacto || this.noValueMessage;
  }

  get activatorCard(): HTMLElement | null {
    return (
      (this.$refs["activator-card"] as (Vue & { $el: HTMLElement }) | null)
        ?.$el ?? null
    );
  }

  openMenu(): void {
    const bounds = this.activatorCard?.getBoundingClientRect();
    this.width = bounds?.width ?? 0;
  }
}
